import { roundPrice } from "~/utils/payment";
import type CartPaymentInfo from "../../cart/CartPaymentInfo";
import type TaxInfo from "../TaxInfo";
import type { TaxInfoType } from "../TaxInfoType";
import type CartTaxStrategy from "./CartTaxStrategy";

export default class SalesCartTaxStrategy implements CartTaxStrategy {
  getTaxInfoType(): TaxInfoType {
    return "sales";
  }

  getTaxInfo(taxInfo: TaxInfo, cartPaymentInfo: CartPaymentInfo): TaxInfo {
    return {
      ...taxInfo,
      amount: roundPrice((cartPaymentInfo.totalPrice ?? 0) * (taxInfo.value ?? 0), "nearest", 2),
    };
  }

  getMonthlyTaxInfo(taxInfo: TaxInfo, cartPaymentInfo: CartPaymentInfo): TaxInfo {
    return {
      ...taxInfo,
      amount: roundPrice((cartPaymentInfo.totalMonthlyPrice ?? 0) * (taxInfo.value ?? 0), "nearest", 2),
    };
  }

  getInitialPaymentTaxInfo(taxInfo: TaxInfo, cartPaymentInfo: CartPaymentInfo): TaxInfo {
    return {
      ...taxInfo,
      amount: roundPrice((cartPaymentInfo.totalInitialPaymentPrice ?? 0) * (taxInfo.value ?? 0), "nearest", 2),
    };
  }
}
